const languageReducer = (language = "en", action) => {
    switch (action.type) {
        case "ADD_LANGUAGE":
            return action.payload;
        default:
            return language;
    }
};

export default languageReducer;